export default __webpack_public_path__ + "static/media/clarity_edit-solid.08dc82a3.svg";